<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        :title="deliveryDateConfirm.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="900px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="deliveryDateConfirm"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="销售订单编号">
              <el-input v-model="deliveryDateConfirm.salesOrderNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="SAP销售订单编号">
              <el-input v-model="deliveryDateConfirm.sapSalesOrderNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="SAP行号">
              <el-input v-model="deliveryDateConfirm.sapRowNo" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <div>
                <el-select v-model="deliveryDateConfirm.status" clearable placeholder="请选择">
                  <el-option
                      v-for="item in deliveryStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物料编号">
              <div style="display: flex;flex-direction: row;">
                <el-input v-model="deliveryDateConfirm.materialNo" placeholder="请输入" readonly>
                  <el-button slot="append" icon="el-icon-search" @click="$refs.selectManageMaterial.open()">
                    选择物料
                  </el-button>
                </el-input>
                <material-select ref="selectManageMaterial" @select="selectManageMaterial"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称">
              <el-input v-model="deliveryDateConfirm.materialName" type="textarea" readonly placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="回复者姓名">
              <el-input v-model="deliveryDateConfirm.responderName" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回复时间">
              <el-date-picker
                  v-model="deliveryDateConfirm.responseTime"
                  type="date"
                  style="width: 295px"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数量">
              <el-input v-model="deliveryDateConfirm.quantity" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回复内容">
              <el-input v-model="deliveryDateConfirm.responseContent" type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import MaterialSelect from "@/views/information/SupplierManage/MaterialSelect";

  export default {
    name:"DeliveryDateConfirmEdit",
    components: {MaterialSelect},
    data() {
      return {
        constant,
        deliveryStatus: constant.toSelect(constant.deliveryStatus),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        deliveryDateConfirm: {
          pkid: "",
          salesOrderNo: "",
          sapSalesOrderNo: "",
          sapRowNo: "",
          materialNo: "",
          materialName: "",
          quantity: "",
          status: "",
          responderName: "",
          responseTime: "",
          responseContent: "",
        },
        ruleValidate: {
          name: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.deliveryDateConfirm.pkid = id;
        console.log(id);
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      selectManageMaterial(row) {
        console.log(row);
        this.deliveryDateConfirm.pkid = row.id;
        this.deliveryDateConfirm.materialNo = row.no;
        this.deliveryDateConfirm.materialName = row.name;
      },
      getData() {
        this.$http
          .get("basic", `deliveryDateConfirms/${this.deliveryDateConfirm.pkid}`)
          .then(resp => {
            //console.log(resp);
            this.deliveryDateConfirm = resp;
          });
      },

      handleSubmit() {
        if (this.deliveryDateConfirm.pkid>0) {
          this.handleSubmitPut();
        }else {
          this.handleSubmitPost();
        }
      },
      handleSubmitPut() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "deliveryDateConfirms", this.deliveryDateConfirm)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitPost() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "deliveryDateConfirms", this.deliveryDateConfirm)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
